module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      "m-spinner",
      {
        'm-spinner--active': _vm.active,
        'm-spinner--floating': _vm.floating,
      }
    ],
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('inline-image-icons-spinner', {
    staticClass: "m-spinner__svg"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2156f126"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Spinner.vue
// module id = 84
// module chunks = 3